import { render, staticRenderFns } from "./PluginTopBarIcon.vue?vue&type=template&id=69036362&"
import script from "./PluginTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./PluginTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports